import React from 'react';
import PropTypes from 'prop-types';
import Async from 'react-select/async';
import { components } from 'react-select';
import axios from 'axios';

import { ucwords } from '../../lib/strings';

const ClientSelect = ({
  value,
  isMulti = false,
  onChange,
  showDefaultOptions = false,
}) => {
  const Input = (props) => {
    return <components.Input {...props} />;
  };

  const Option = (props) => {
    const record = props.data.record;
    return (
      <components.Option {...props}>
        <p className="mb-0">{props.children}</p>
        <small className="text-muted">{ucwords(record.userEmail)}</small>
      </components.Option>
    );
  };

  const loadOptions = async (term) => {
    const endpoint = `/users?search=${term}&userType=client`;
    const results = await axios.get(endpoint);
    const opts = [];

    results.data.rows.forEach((item) => {
      opts.push({
        value: item.userId,
        label: `${item.userLastName}, ${item.userFirstName}`,
        record: item,
      });
    });

    return opts;
  };

  return (
    <Async
      components={{ Option, Input }}
      isMulti={isMulti}
      isClearable={true}
      isSearchable={true}
      loadOptions={loadOptions}
      onChange={onChange}
      value={value}
      defaultOptions={showDefaultOptions}
      placeholder="Search clients..."
    />
  );
};

ClientSelect.propTypes = {
  value: PropTypes.any,
  isMulti: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  showDefaultOptions: PropTypes.bool,
};

export default ClientSelect;
